import {useEffect, useRef, useState} from "react";
import fetcher from "app/request/fetcher";
import useAppContext from "common/hooks/use-app-context";
import {toQueryString} from "common/lib/ext/object";
import useWidgetState from "./use-widget-state";

// NOTE: Ensures requests to trigger integrations are finished before redirecting
export default function useSurveyEffect() {
  const {locale} = useAppContext();
  const {assessments} = useWidgetState();
  const [completedIDs, setCompletedIDs] = useState([]);
  const requests = useRef({});

  useEffect(() => {
    if(!assessments) { return; }

    assessments.forEach((assessment) => {
      if(!assessment.completed) { return; }
      if(requests.current[assessment.id]) { return; }

      const request = {id: assessment.id, controller: new AbortController()};
      requests.current[assessment.id] = request;

      const queryString = toQueryString({
        survey_key: assessment.surveyID,
        survey_type: assessment.surveyType
      });
      const url = `/api/public/assessments/${assessment.id}/complete?${queryString}`;

      fetcher({locale, method: "PUT", signal: request.controller.signal, url}).then(() => {
        delete requests.current[assessment.id];

        setCompletedIDs((ids) => [...ids, assessment.id]);
      }).catch((error) => {
        console.warn("Assessment Completed Request", error); /* eslint-disable-line no-console */

        delete requests.current[assessment.id];
      });
    });
  }, [assessments]);

  useEffect(() => (
    () => (
      Object.values(requests.current).forEach(({controller, id}) => {
        console.warn("Cancelled Assessment Completed Request", id); /* eslint-disable-line no-console */
        controller.abort();
      })
    )
  ), []);

  if(!assessments) { return {completed: false, loading: false}; }

  const loading = assessments.every(({completed}) => completed);
  const completed = assessments.every(({id}) => completedIDs.includes(id));

  return {completed, loading};
}
